$(function(){
	if ($('.js-go-back').length) {
		$('.js-go-back').click(function(){
		    parent.history.back();
		    return false;
		});
	}
});